import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Settings, Sparkles, PlayCircle } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Configura tu Identidad',
    desc: 'Diseñas tu avatar y clonas tu voz de autoridad en 15 minutos.',
    icon: <Settings size={28} className="text-brand-cyan" data-id="element-147" />
  }, {
    num: '2',
    title: 'Genera el Contenido',
    desc: 'Usas nuestros prompts de ingeniería inversa para crear 7 guiones ganadores.',
    icon: <Sparkles size={28} className="text-brand-purpleLight" data-id="element-148" />
  }, {
    num: '3',
    title: 'Ensambla y Programa',
    desc: 'Sincronizas audio y video con un clic y dejas que el algoritmo trabaje por ti.',
    icon: <PlayCircle size={28} className="text-brand-cyan" data-id="element-149" />
  }];
  return <Section className="bg-brand-darker/50 border-y border-white/5 overflow-hidden" data-id="element-150">
      <div className="text-center mb-20" data-id="element-151">
        <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-152">Cómo Funciona</h2>
        <p className="text-xl text-brand-gray max-w-2xl mx-auto" data-id="element-153">
          Un flujo de trabajo optimizado para crear activos digitales de alto
          valor en tiempo récord.
        </p>
      </div>

      <div className="max-w-5xl mx-auto relative" data-id="element-154">
        {/* Connecting Line */}
        <div className="hidden md:block absolute top-1/2 left-0 w-full h-1 bg-gradient-to-r from-brand-cyan/20 via-brand-purple/50 to-brand-cyan/20 -translate-y-1/2 z-0" data-id="element-155" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative z-10" data-id="element-156">
          {steps.map((step, index) => <motion.div key={index} className="relative flex flex-col items-center text-center" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} data-id="element-157">
              {/* Number Badge */}
              <div className="absolute -top-6 -left-2 md:left-1/2 md:-translate-x-1/2 md:-top-8 text-6xl md:text-8xl font-black text-white/5 select-none z-0" data-id="element-158">
                {step.num}
              </div>

              {/* Icon Container */}
              <div className="w-20 h-20 rounded-2xl glass-card border-brand-cyan/30 flex items-center justify-center mb-8 relative z-10 shadow-[0_0_30px_rgba(0,240,255,0.15)] bg-brand-dark" data-id="element-159">
                {step.icon}
                <div className="absolute -bottom-3 -right-3 w-8 h-8 rounded-full bg-brand-darker border border-brand-cyan/50 flex items-center justify-center text-sm font-bold text-brand-cyan" data-id="element-160">
                  {step.num}
                </div>
              </div>

              <div className="glass-card p-6 rounded-2xl w-full border-white/5 hover:border-brand-purple/30 transition-colors relative z-10" data-id="element-161">
                <h3 className="text-2xl font-bold mb-3 text-white" data-id="element-162">
                  {step.title}
                </h3>
                <p className="text-brand-gray leading-relaxed" data-id="element-163">{step.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </Section>;
}